import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlumniConnectRoutingModule } from './alumni-connect-routing.module';
import { OverviewComponent } from './overview/overview.component';
import { AlumniConnectComponent } from './alumni-connect.component';
import { AlumniOfficeContactsComponent } from './alumni-office-contacts/alumni-office-contacts.component';
import { StudentDatabaseComponent } from './student-database/student-database.component';


@NgModule({
  declarations: [
    OverviewComponent,
    AlumniConnectComponent,
    AlumniOfficeContactsComponent,
    StudentDatabaseComponent
  ],
  imports: [
    CommonModule,
    AlumniConnectRoutingModule
  ]
})
export class AlumniConnectModule { }
